// extracted by mini-css-extract-plugin
export default {"explainer-wrapper":"style_explainer-wrapper__vZbun","explainerWrapper":"style_explainer-wrapper__vZbun"};